import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { PoolTypeEnum } from '@shared/Enums'
import React, { FC } from 'react'

interface Props {
  vaultType: string
  handleChange: (event: SelectChangeEvent<string>) => void
}

export const ValutTypeStep: FC<Props> = ({ vaultType, handleChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="vault-select-label">Vault Type</InputLabel>
      <Select
        labelId="vault-select-label"
        id="vault-select"
        value={vaultType}
        label="Vault Type"
        onChange={handleChange}
      >
        <MenuItem value={PoolTypeEnum.FlexibleRate}>Flexible Term Vault</MenuItem>
        <MenuItem value={PoolTypeEnum.Term}>Fixed Term Vault</MenuItem>
        <MenuItem value={PoolTypeEnum.Dynamic}>Dynamic Vault</MenuItem>
      </Select>
    </FormControl>
  )
}
